import { render, staticRenderFns } from "./MediaFolder.vue?vue&type=template&id=d41515e0&"
import script from "./MediaFolder.vue?vue&type=script&lang=ts&"
export * from "./MediaFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports